import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class FinVacationTourneeEvent extends UserEvent {
  public static NAME = 'FIN_TOURNEE_EVENT';

  constructor(
    public idCreneau: string,
    public fin: dayjs.Dayjs,
    public champsPersonnalises: ChampCompteRendu[] = [],
    coordinates?: Coordinates
  ) {
    super(FinVacationTourneeEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: FinVacationTourneeEvent): FinVacationTourneeEvent {
    return new FinVacationTourneeEvent(obj.idCreneau, dayjs(obj.fin), obj.champsPersonnalises, obj.coordinates);
  }
}
